import { update } from './update';

export function request({ postCode, addressLine1, addressLine2, city }) {
    return {
        type: 'USER_CHANGE_ADDRESS_REQUEST',
        postCode,
        addressLine1,
        addressLine2,
        city
    };
}

export function error(errors) {
    return {
        type: 'USER_CHANGE_ADDRESS_ERROR',
        errors
    };
}

export function finish(user) {
    return (dispatch) => {
        dispatch(update(user));

        dispatch({
            type: 'USER_CHANGE_ADDRESS_FINISH'
        });
    };
}

export function clear() {
    return {
        type: 'USER_CHANGE_ADDRESS_CLEAR'
    };
}
